import styled, { keyframes } from 'styled-components';
import { gradient } from '../../../helpers/styleUtils';

const meterMoveHorz = keyframes`
    from {
        transform: translateX(0);
    }
    to {
        transform: translateX(-100%);
    }
`;

const meterMoveVert = keyframes`
    from {
        transform: translateY(0);
    }
    to {
        transform: translateY(-100%);
    }
`;

const meterMoveHorzRESET = keyframes`
    from {
        transform: translateX(-100%);
    }
    to {
        transform: translateX(0);
    }
`;

const meterMoveVertRESET = keyframes`
    from {
        transform: translateY(-100%);
    }
    to {
        transform: translateY(0);
    }
`;

const StyledTimeBar = styled.section`
  background: ${props => props.theme.colors.white};
  border-radius: 10px;
  bottom: 0;
  flex: 1;
  height: 4px;
  overflow: hidden;
  position: relative;
  z-index: 1;

  @media screen and (min-width: ${props => props.theme.breakpoints.md}) {
    height: 6px;
  }

  @media screen and (min-width: ${props => props.theme.breakpoints.xl}) {
    flex: 1;
    width: 10px;
  }
`;

export const Meter = styled.span`
  ${gradient.background(
    `90deg`,
    props => props.theme.colors.quaternary,
    props => props.theme.colors.red
  )};
  border-radius: 10px;
  bottom: 0;
  opacity: ${props => (props.horz ? '1' : '0')};
  height: 4px;
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
  transition: transform ${props => props.theme.transition.durationShort}
    ${props => props.theme.transition.easeOut};

  &.ready {
    animation: ${props =>
        props.horz && props.started ? meterMoveHorz : meterMoveVert}
      ${props => props.time}s forwards linear;
    animation-play-state: ${props => (props.started ? 'running' : 'paused')};
  }

  &.restarted {
    animation: ${props =>
        props.horz ? meterMoveHorzRESET : meterMoveVertRESET}
      1s ${props => props.theme.transition.easeOut};
  }

  @media screen and (min-width: ${props => props.theme.breakpoints.md}) {
    height: 6px;
  }

  @media screen and (min-width: ${props => props.theme.breakpoints.xl}) {
    ${gradient.background(
      `0deg`,
      props => props.theme.colors.red,
      props => props.theme.colors.quaternary
    )};
    opacity: ${props => (props.vert ? '1' : '0')};
    height: 100%;
    width: 10px;
  }
`;

export default StyledTimeBar;



// WEBPACK FOOTER //
// ./src/components/atoms/TimeBar/TimeBar.styled.js